import React, { useState } from "react"
import styled, { css } from "styled-components"
import { useParts } from "../provider/PartsContext"
import ToggleInfoPanelButton from "./ToggleInfoPanelButton"
const StyledInfoPanelWrapper = styled.div`
  background-color: white;
  border: 1px solid red;
  width: 200px;
  height: 200px;
  position: absolute;
  right: 0px;
  top: 100px;
`
const InfoPanel = () => {
  const { parts, visible } = useParts()
  return (
    <>
      <StyledInfoPanelWrapper>
        {parts.map((model) => {
          const id = Object.keys(model)[0]
          const name = model[id].name
          return <p key={id}>{name}</p>
        })}
      </StyledInfoPanelWrapper>
    </>
  )
}
export default InfoPanel
